import { Grid } from "@material-ui/core";
import { School } from "@material-ui/icons";
import { useEffect, useState } from "react";
import { RootStateOrAny, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import RxBlobImageViewer from "../../components/RxBlobImageViewer";
import RxPaper from "../../components/RxPaper";
import RxProductContainer from "../../components/RxProductContainer";
import RxProductContent from "../../components/RxProductContent";
import RxTitleSeperator from "../../components/RxTitleSeperator";
import api from "../../config/AxiosConfig";
import { ProductCategoryObject } from "../../constants/CommonObject";
import styles from "./MainPage.module.css";

const MainPage = () => {
	const history = useHistory();
	const [productCategories, setProductCategories] = useState<
		ProductCategoryObject[]
	>([]);

	const getProductCategories = async () => {
		const response: ProductCategoryObject[] = await api.get(
			"/1/product-categories"
		);
		setProductCategories(Array.isArray(response) ? response : []);
	};

	const email: string = useSelector(
		(state: RootStateOrAny) => state.user.userInfo?.email ?? ""
	);

	useEffect(() => {
		getProductCategories();
	}, []);

	return (
		<RxPaper className={styles.main}>
			<Grid
				container
				spacing={1}
				direction="row"
				justifyContent="center"
				alignItems="center"
				alignContent="center"
			>
				<Grid item xs={12} sm={12}>
					<Grid container spacing={1}>
						<Grid item xs={12} sm={12}>
							<Grid container spacing={1}>
								<RxTitleSeperator
									label="Satış İşlemleri"
									className={styles.seperatorLineTop}
								/>
							</Grid>
							<Grid container spacing={5}>
								{productCategories.map((category, index) => (
									<Grid item xs={6} sm={4} key={"grid_main_" + index}>
										<RxProductContainer
											key={"rxpc_" + index}
											className={styles.menuContainerPapaer}
											children={
												<RxProductContent
													key={"rxpc_inner_" + index}
													title={category.name}
													image={
														<RxBlobImageViewer
															key={"rxpc_inner_image_" + index}
															image={category.image}
															alt={category.name}
															height="64px"
														/>
													}
												/>
											}
											onClick={() => {
												history.push("/sale/" + category.id);
											}}
										/>
									</Grid>
								))}
							</Grid>
						</Grid>
					</Grid>
				</Grid>
				{email.endsWith("edu.tr") && (
					<Grid item xs={12} sm={12}>
						<Grid container spacing={1}>
							<Grid item xs={12} sm={12}>
								<Grid container spacing={1}>
									<RxTitleSeperator
										label="Lisans İşlemleri"
										className={styles.seperatorLine}
									/>
								</Grid>
								<Grid container spacing={5}>
									<Grid item xs={6} sm={4} key={"grid_main_al"}>
										<RxProductContainer
											key={"rxpc_al"}
											className={styles.menuContainerPapaer}
											children={
												<RxProductContent
													key={"rxpc_inner_al"}
													title={"Akademik Lisans İşlemleri"}
													image={
														<School
															color="primary"
															className={styles.alIcon}
														/>
													}
												/>
											}
											onClick={() => {
												history.push("/academic-licence/");
											}}
										/>
									</Grid>
								</Grid>
							</Grid>
						</Grid>
					</Grid>
				)}
			</Grid>
		</RxPaper>
	);
};

export default MainPage;
